





















import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import Alert from '@/components/Shared/Alert.vue';
import KpiTargetList from '@/components/KpiTargets/KpiTargetList.vue';
import PageNames from '@/router/PageNames';

@Component({
	name: 'KpiSettings',
	components: { Alert, KpiTargetList }
})
export default class extends GiganautVue {

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

	get loading() {
		return false;
	}
}
